// @flow
/*:: import type {Location} from 'react-router' */
import * as React from 'react'
import {withRouter} from 'react-router'

// https://reacttraining.com/web/guides/scroll-restoration/scroll-to-top
/*::
type Props = {
  location: Location,
  children: React.Node
}
*/
export default withRouter(class extends React.Component/*:: <Props> */ {
  displayName = 'ScrollTop'
  componentDidUpdate (prevProps/*: Props */) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render () {
    return this.props.children
  }
})



// WEBPACK FOOTER //
// ./src/ScrollTop.js